import type {Values} from '@wix/devzai-utils-common';

export const BymoPageSocialLinksSize = {
    Small: 'Small',
    Medium: 'Medium',
    Large: 'Large',
} as const;

export type BymoPageSocialLinksSize = Values<typeof BymoPageSocialLinksSize>;
